import { Component } from "react";

class LeadParagraph extends Component {
  render() {
    return <p className="leadParagraph">{this.props.text}</p>;
  }
}

LeadParagraph.propTypes = {
  text: React.PropTypes.string.isRequired,
};

export default LeadParagraph;
